import { Button } from '@/shared/components/ui/button'

import { useVersionUpdate, type VersionUpdateOptions } from './useVersionUpdate'

export type VersionUpdateNoticeProps = VersionUpdateOptions

export function VersionUpdateNotice(props: VersionUpdateNoticeProps) {
  const { updateAvailable, reload } = useVersionUpdate(props)

  if (!updateAvailable) return null

  return (
    <aside
      className="bg-card text-card-foreground fixed inset-x-4 bottom-4 z-50 flex max-w-md flex-col gap-4 rounded-xl border p-4 shadow-lg sm:right-6 sm:left-auto sm:flex-row sm:items-center"
      role="status"
      aria-live="polite"
    >
      <div className="min-w-0 flex-1 space-y-1">
        <p className="font-medium">Nueva versión disponible</p>
        <p className="text-muted-foreground text-sm">
          Hay una nueva versión de Alto Palermo disponible.
        </p>
      </div>

      <Button type="button" size="sm" className="shrink-0" onClick={reload}>
        Actualizar ahora
      </Button>
    </aside>
  )
}
